import React, { useState, useEffect, useRef } from 'react';

import { motion } from "framer-motion";

import NaverLogin from 'react-naver-login';
import KakaoLogin from "react-kakao-login";

import { toast } from 'react-toastify';

import { useLang, usePopup, useUser } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import { errorMessage } from "../utils/utils";
import * as APIS from "../utils/service";

import Button from './Button';
import ContainerLoader from './ContainerLoader';


import images from '../libs/images';
import consts from '../libs/consts';

export default function Sign() {

    const ref = useRef();

    const { signPop, signTermPop, closeSignTermPop } = usePopup();
    const { country } = useLang();
    
    const [ title, settitle ] = useState('');
    const [ desc, setdesc ] = useState('');

    const [ error, setError ] = useState({});

    const [ load, setload ] = useState(true);

    useEffect(() => {

        if(signTermPop) {
            // settitle(consts?.termTypeConsts?.find(x => x?.idx === signTermPop)?.title);
            dataFunc();
        }

    }, [signTermPop]);

    const closeFunc = () => {
        closeSignTermPop();

        setTimeout(() => {
            settitle('');
            setdesc('');
        }, 100)
    }

    const dataFunc = () => {

        setload(true);

        let sender = {
            type: signTermPop,
            lang: country
        }

        console.log('sender', sender);

        APIS.post('/config/policy', sender).then(( { data } ) => {
            console.log('data', data);

            settitle(data?.title);
            setdesc(data?.info);
     
        }).catch(({ response }) => {
            closeFunc();
            errorMessage(response?.data);
        }).finally(() => {
            setTimeout(() => {
                setload(false);
            }, 100)
        });

    }

    return (
        <motion.div
            className="loader_box_blur"
            initial={consts.loaderBlurVariants.closed}
            animate={signTermPop ? "open" : "closed"}
            variants={consts.loaderBlurVariants}
        >
            <motion.div
                className="term_section"
                initial={consts.loginBoxVariants.closed}
                animate={(signTermPop) ? "open" : "closed"}
                variants={consts.loginBoxVariants}
            >
                <div
                    className="login_root"
                >
                    <ContainerLoader load={load}/>
                    
                    <div className='term_content'>
                        <p className='title'>{title}</p>
                        <p className='desc'>{desc}{desc}{desc}</p>
                    </div>
                    

                    <Button title={<LangText id={'btn_close'}/>} onClick={closeFunc}/>
                </div>
                

            </motion.div>


        </motion.div>
    )    
}